export default {
    apiUrl: 'http://localhost:3000',
    notificationUrl: 'https://us-central1-hsbusquedas.cloudfunctions.net/apiHsBusquedas',
}